/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, {useMemo} from "react";
import {useHtmlClassService} from "../../../_metronic/layout/_core/MetronicLayout";

export const SubHeader = ({ className }) => {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      config: uiService.config,
      subheaderCssClasses: uiService.getClasses("subheader", true),
      subheaderContainerCssClasses: uiService.getClasses(
          "subheader_container",
          true
      )
    };
  }, [uiService]);

  return (
      <div
          id="kt_subheader"
          className={`subheader py-2 py-lg-4   ${layoutProps.subheaderCssClasses} ${className}`}
      >
        <div
            className={`${layoutProps.subheaderContainerCssClasses} subheader-container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap`}
        >

          {/* Info */}
          <div className="d-flex align-items-center flex-wrap mr-1">

          </div>

        </div>
      </div>
  );
}
